module.exports = __webpack_public_path__ + "static/media/SR_featureWalkthrough_mobile_01.9a660d0d.mp4";